const initEmaillogData = {
  
}


export function emaillogData(
  state = initEmaillogData,
  action
) {
  switch (action.type) {
    case "EMAIL_LOG_FETCH_DATA_SUCCESS":
      return action.dataEmaillog;
    default:
      return state;
  }
}
